var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bnfhpicture"}},[_c('commonHeader'),_vm._v(" "),_c('div',{attrs:{"tyle":"width:100%;height:240px;"}},[_c('div',{staticStyle:{"width":"100%","z-index":"8"},style:({ height: _vm.mapheightSize + 'px' }),attrs:{"id":"historymap"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1998cce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module-clickbnfhPicture/index.vue
// module id = null
// module chunks = 